import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import 'moment/locale/ko';
import DetectorController, { DevicePathLogType } from '../../controller/DetectorController';
import 'moment/locale/ko';
import moment from 'moment';
import DateTab from '../DateTab';
import Pagination from '../Pagination';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  pathLogData: DevicePathLogType[];
  openPathLog: any;
  pageCount: number;
  setPageCount: (pageCount: number) => void;
};

type Params =
  | 'timer'
  | 'sector'
  | 'category'
  | 'product'
  | 'card'
  | 'voucher'
  | 'coupon'
  | 'adver'
  | 'concierge'
  | 'storeChat'
  | 'cs'
  | 'cart'
  | 'event'
  | 'navigate'
  | 'payment'
  | 'order'
  | 'morningCall'
  | 'arrival'
  | 'checkout'
  | 'cancel'
  | 'rating'
  | 'lang'
  | 'click'
  | 'guide'
  | 'error';

type ParamsType = {
  params: Params;
  path_url: string;
  title: string;
};

const ParamItems: ParamsType[] = [
  {
    params: 'timer',
    path_url: `${process.env.PUBLIC_URL}/svg/status_timer.svg`,
    title: '특정 시간 로직',
  },
  {
    params: 'sector',
    path_url: `${process.env.PUBLIC_URL}/svg/status_sector.svg`,
    title: '업종',
  },
  {
    params: 'category',
    path_url: `${process.env.PUBLIC_URL}/svg/status_menuCategory.svg`,
    title: '카테고리',
  },
  {
    params: 'product',
    path_url: `${process.env.PUBLIC_URL}/svg/status_menu.svg`,
    title: '상품',
  },
  {
    params: 'card',
    path_url: '',
    title: '호텔 소개',
  },
  {
    params: 'voucher',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '주변 맛집',
  },
  {
    params: 'coupon',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '쿠폰',
  },
  {
    params: 'adver',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '광고',
  },
  {
    params: 'concierge',
    path_url: `${process.env.PUBLIC_URL}/svg/status_concierge.svg`,
    title: '프론트요청',
  },
  {
    params: 'storeChat',
    path_url: `${process.env.PUBLIC_URL}/svg/status_store.svg`,
    title: '매장 채팅',
  },
  {
    params: 'cs',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cs.svg`,
    title: '노크노크 긴급요청',
  },
  {
    params: 'cart',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cart.svg`,
    title: '장바구니 변동',
  },
  {
    params: 'event',
    path_url: `${process.env.PUBLIC_URL}/svg/status_event.svg`,
    title: '이벤트',
  },
  {
    params: 'navigate',
    path_url: `${process.env.PUBLIC_URL}/svg/status_move_path.svg`,
    title: '페이지 이동',
  },
  {
    params: 'payment',
    path_url: `${process.env.PUBLIC_URL}/svg/status_payment.svg`,
    title: '결제',
  },
  {
    params: 'order',
    path_url: `${process.env.PUBLIC_URL}/svg/status_order.svg`,
    title: '주문',
  },
  {
    params: 'morningCall',
    path_url: '',
    title: '모닝콜',
  },
  {
    params: 'arrival',
    path_url: '',
    title: '주문 도착',
  },
  {
    params: 'checkout',
    path_url: `${process.env.PUBLIC_URL}/svg/ic_calendar.svg`,
    title: '체크아웃',
  },
  {
    params: 'cancel',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cancel_payment.svg`,
    title: '주문 취소',
  },
  {
    params: 'rating',
    path_url: `${process.env.PUBLIC_URL}/svg/status_rating.svg`,
    title: '리뷰',
  },
  {
    params: 'lang',
    path_url: `${process.env.PUBLIC_URL}/svg/status_language.svg`,
    title: '언어 설정',
  },
  {
    params: 'click',
    path_url: `${process.env.PUBLIC_URL}/svg/status_click.svg`,
    title: '버튼 클릭',
  },
  {
    params: 'guide',
    path_url: `${process.env.PUBLIC_URL}/svg/ic_edit.svg`,
    title: '노크노크 가이드',
  },
  {
    params: 'error',
    path_url: `${process.env.PUBLIC_URL}/svg/status_error.svg`,
    title: '연결 불량',
  },
];

const AllDetailModal = ({
  isVisible,
  setVisible,
  pathLogData,
  openPathLog,
  pageCount,
  setPageCount,
}: Props) => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);

  const getStatusComment = (params: Params) => {
    const paramState = ParamItems.find((item) => item.params === params);

    return (
      paramState && (
        <div className="row">
          {paramState.path_url.length > 0 && (
            <img src={paramState.path_url} alt="장바구니 변동" width={16} />
          )}
          <p>{paramState.title}</p>
        </div>
      )
    );
  };
  const onCloseModal = () => {
    setVisible(false);
    setCurrentPage(1);
    setPageCount(1);
  };

  const openPathLogUser = (startDate: Date, endDate: Date) => {
    openPathLog(-1, startDate, endDate, 0);
    setCurrentPage(1);
  };

  const pressPageNumber = async (selected: { selected: number }) => {
    setCurrentPage(selected.selected + 1);
    openPathLog(-1, startDate, endDate, selected.selected * 10);
  };

  return (
    <Style>
      {isVisible && (
        <div className="modalWrap">
          <div className="modalBackground" onClick={onCloseModal}></div>
          <div className="modal">
            <div className="content">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기"
                width={28}
                className="modalCloseButton"
                onClick={onCloseModal}
              />

              <DateTab
                type="oneDay"
                openPathLog={openPathLogUser}
                changeStartDate={setStartDate}
                changeEndDate={setEndDate}
              />

              <div className="title">
                <h2 className="date">날짜</h2>
                <h2 className="room">호실</h2>
                <h2 className="action">클릭</h2>
                <h2 className="detail">상세내역</h2>
              </div>
              <div className="contentWrap">
                {pathLogData && pathLogData.length > 0 ? (
                  pathLogData.map((data, index) => {
                    return (
                      <div className="modalContent" key={index}>
                        <p className="date">
                          {moment(data.created_at).format('YYYY/MM/DD HH:mm:ss')}
                        </p>
                        <p className="room">{data.name}</p>
                        <p className="action">{getStatusComment(data.params)}</p>
                        <p className="detail">{data.params2}</p>
                      </div>
                    );
                  })
                ) : (
                  <h2 className="noneList">클릭 내역 없음</h2>
                )}
              </div>
              <Pagination
                pageCount={pageCount}
                handlePageClick={pressPageNumber}
                forcePage={currentPage - 1}
              />
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default AllDetailModal;

const Style = styled.div`
  h2 {
    font-size: 16px !important;
    font-weight: 500;
  }
  p {
    margin: 10px 0;
    font-size: 12px;
  }

  .content {
    width: 70%;
    padding: 2%;
    z-index: 9999;
    text-align: left;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
  }
  .modalCloseButton {
    position: absolute;
    top: 3%;
    right: 2%;
    cursor: pointer;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .title,
  .modalContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    margin-top: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ddd;
  }
  .contentWrap {
    max-height: 65vh;
    overflow-y: auto;
  }
  .modalContent {
    border-bottom: 1px solid #eee;
  }

  .date {
    flex: 0 0 20%;
  }
  .room {
    flex: 0 0 10%;
    text-align: center;
  }
  .action {
    flex: 0 0 30%;
    text-align: center;
  }
  .detail {
    flex: 0 0 40%;
    white-space: pre-line;
  }
  .noneList {
    margin: 50px 0;
  }

  /* 스크롤바 */
  .contentWrap::-webkit-scrollbar {
    width: 4px;
    background-color: #d1d1d1;
    border-radius: 50px;
  }
  .contentWrap::-webkit-scrollbar-thumb {
    width: 4px;
    background-color: #000;
    border-radius: 50px;
  }
  @media (max-width: 900px) {
    .content {
      width: 90%;
      padding: 4%;
    }
  }
`;
